import { render, staticRenderFns } from "./BusinessInterestsTransferred.vue?vue&type=template&id=0a45e248&"
import script from "./BusinessInterestsTransferred.vue?vue&type=script&lang=js&"
export * from "./BusinessInterestsTransferred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports